
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.991 6.069l-5.698.945 4.036 4.04a.95.95 0 01.268.813l-.844 5.607 5.192-2.527a.972.972 0 01.85 0l5.192 2.527-.844-5.607a.95.95 0 01.268-.813l4.036-4.04-5.697-.945a.965.965 0 01-.693-.495L10.37.534 7.684 5.573v.001a.964.964 0 01-.693.495zm12.541.959z","stroke":"#172542"}})])
          )
        }
      }
    